export const contractors = [
    { value: "SH", label: "SH" },
    { value: "LIKO", label: "LIKO" },
    { value: "TTK", label: "TTK" },
    { value: "SP", label: "SP"}
];
